import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import store from './../store';

Vue.use(Router);
Vue.use(Meta);

const Layout = () => import('@/components/layout.vue')
// 主页面
const Home = () => import('@/views/home/home')

//应用开发主页面
const appDevelopIndex = () => import('@/views/appDevelop/index')
const applySpecialApp = () => import('@/views/specialApp/applySpecialApp')
const DevelopDoc = () => import('@/views/specialApp/developDoc')
const LightApp = () => import('@/views/lightApp/lightApp')
const applyLightApp = () => import('@/views/lightApp/applyLightApp')

//科研项目主页面
const researchIndex = () => import('@/views/research/index')
const research = () => import('@/views/research/research')
const targeted = () => import('@/views/research/targeted')

//产品示例
const AppList = () => import('@/views/product/appList')
const GenomeReport = () => import('@/views/product/genomeReport')
const Appdetail = () => import('@/views/product/appdetail')

const community = () => import('@/views/bbs/bbs')

//登录注册页面
const login = () => import('@/views/login/login')
const register = () => import('@/views/login/register')
const resetPassword = () => import('@/views/login/resetPassword')

//账户中心
const userInfo = () => import('@/views/user/userInfo')
const alterPassword = () => import('@/views/user/alterPassword')
const findPassword = () => import('@/views/user/findPassword')
const fillUserInfo = () => import('@/views/user/fillUserInfo')

//管理中心
const sAppList = () => import('@/views/managementCenter/sAppList')
const creatSpecialApp = () => import('@/views/managementCenter/creatSpecialApp')

//科研调查相关页面
const creatSurvey = () => import('@/views/research/survey/creatSurvey')
const editQuestion = () => import('@/views/research/survey/editQuestion')
const setAnswer = () => import('@/views/research/survey/setAnswer')
const setOrder = () => import('@/views/research/survey/setOrder')
const setQuestions = () => import('@/views/research/survey/setQuestions')
const surveyDetail = () => import('@/views/research/survey/surveyDetail')
const viewData = () => import('@/views/research/survey/viewData')
const volumeSetQuestions = () => import('@/views/research/survey/volumeSetQuestions')
const recycle = () => import('@/views/research/survey/recycle')

//科研计划相关页面
const creatPlan = () => import('@/views/research/plan/creatPlan')
const planDetail = () => import('@/views/research/plan/planDetail')
const questionnaireProgress = () => import('@/views/research/plan/questionnaireProgress')
const updateProgress = () => import('@/views/research/plan/updateProgress')
const volunteersManage = () => import('@/views/research/plan/volunteersManage')
const planProgress = () => import('@/views/research/plan/planProgress')

//定向投放相关页面
const creatTask = () => import('@/views/research/targeted/creatTask')
const completedTask = () => import('@/views/research/targeted/completedTask')

// 导入数据
const upload = () => import('@/views/upload/upload')
const getUploadDataSteps = () => import('@/views/upload/getDataSeps')

// 基因检测FAQ
const geneFAQ = () => import('@/views/geneFAQ/FAQ')
const geneFAQdetail = () => import('@/views/geneFAQ/FAQdetail')

//模型应用
const modelAppList = () => import('@/views/modelApp/list')
const createdModelApp = () => import('@/views/modelApp/created')
const modelAppDetail = () => import('@/views/modelApp/detail')
const editBasic = () => import('@/views/modelApp/edit/basic')
const editResult = () => import('@/views/modelApp/edit/result')
const editReferences = () => import('@/views/modelApp/edit/references')
const modelMarket = () => import('@/views/modelApp/modelMarket')

//跳转微信小程序中转页
const toMiniProgram = () => import('@/views/toMiniProgram/toMiniProgram')

// 页面刷新时，重新赋值token
if (sessionStorage.getItem('email')) {
  store.commit('getLocalUser')
}

if (sessionStorage.getItem('state_id')) {
  store.commit('getStateId')
}


const router = new Router({
  //mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/',
      component: Layout,
      children: [
        { path: 'home', name: 'home', component: Home },
        //应用开发主页面
        {
          path: 'appDevelopIndex',
          name: 'appDevelopIndex',
          component: appDevelopIndex,
          children: [
            { path: 'applySpecialApp', name: 'applySpecialApp', component: applySpecialApp },
            { path: 'developDoc', name: 'developDoc', component: DevelopDoc },
            { path: 'lightApp', name: 'lightApp', component: LightApp },
            { path: 'applyLightApp', name: 'applyLightApp', component: applyLightApp },
          ]
        },
        //研究管理页面
        {
          path: 'researchIndex',
          name: 'researchIndex',
          component: researchIndex,
          children: [
            { path: 'research', name: 'research', component: research },
            { path: 'targeted', name: 'targeted', component: targeted },
            //科研调查相关页面
            { path: 'creatSurvey', name: 'creatSurvey', component: creatSurvey },
            { path: 'editQuestion', name: 'editQuestion', component: editQuestion },
            { path: 'setAnswer', name: 'setAnswer', component: setAnswer },
            { path: 'setOrder', name: 'setOrder', component: setOrder },
            { path: 'setQuestions', name: 'setQuestions', component: setQuestions },
            { path: 'surveyDetail', name: 'surveyDetail', component: surveyDetail },
            { path: 'viewData', name: 'viewData', component: viewData },
            { path: 'volumeSetQuestions', name: 'volumeSetQuestions', component: volumeSetQuestions },
            { path: 'recycle', name: 'recycle', component: recycle },

            //科研计划相关页面
            { path: 'creatPlan', name: 'creatPlan', component: creatPlan },
            { path: 'planDetail', name: 'planDetail', component: planDetail },
            { path: 'questionnaireProgress', name: 'questionnaireProgress', component: questionnaireProgress },
            { path: 'updateProgress', name: 'updateProgress', component: updateProgress },
            { path: 'volunteersManage', name: 'volunteersManage', component: volunteersManage },
            { path: 'planProgress', name: 'planProgress', component: planProgress },

            //定向投放相关页面
            { path: 'creatTask', name: 'creatTask', component: creatTask },
            { path: 'completedTask', name: 'completedTask', component: completedTask },
          ]
        },

        { path: 'appList', name: 'appList', component: AppList },
        { path: 'genomeReport', name: 'genomeReport', component: GenomeReport },
        { path: 'appdetail', name: 'appdetail', component: Appdetail },

        //登录注册页面
        { path: 'login', name: 'login', component: login },
        { path: 'register', name: 'register', component: register },
        { path: 'resetPassword', name: 'resetPassword', component: resetPassword },

        //账户中心
        { path: 'userInfo', name: 'userInfo', component: userInfo },
        { path: 'alterPassword', name: 'alterPassword', component: alterPassword },
        { path: 'findPassword', name: 'findPassword', component: findPassword },
        { path: 'fillUserInfo', name: 'fillUserInfo', component: fillUserInfo },

        //管理中心
        { path: 'sAppList', name: 'sAppList', component: sAppList },
        { path: 'creatSpecialApp', name: 'creatSpecialApp', component: creatSpecialApp },

        //模型应用
        { path: 'modelAppList', name: 'modelAppList', component: modelAppList },
        { path: 'createdModelApp', name: 'createdModelApp', component: createdModelApp },
        { path: 'modelAppDetail', name: 'modelAppDetail', component: modelAppDetail },
        { path: 'editBasic', name: 'editBasic', component: editBasic },
        { path: 'editResult', name: 'editResult', component: editResult },
        { path: 'editReferences', name: 'editReferences', component: editReferences },
        { path: 'editReferences', name: 'editReferences', component: editReferences },
        { path:'/modelMarket', name: 'modelMarket', component: modelMarket },
      ]
    },
    { path: '/community', name: 'community', component: community },
    { path: '/upload/:id', name: 'upload', component: upload },
    { path:'/getUploadDataSteps', name: 'getUploadDataSteps', component: getUploadDataSteps },
    { path:'/geneFAQ', name: 'geneFAQ', component: geneFAQ },
    { path:'/geneFAQdetail', name: 'geneFAQdetail', component: geneFAQdetail },
    { path:'/toMiniProgram', name: 'toMiniProgram', component: toMiniProgram },
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})
// router.beforeEach((to, from, next) => {
//   setTimeout(()=>{
//     var _hmt = _hmt || [];
//     (function() {
//       var hm = document.createElement("script");
//       hm.src = "https://hm.baidu.com/hm.js?3153747651d1860e99943351ed233499";
//       var s = document.getElementsByTagName("script")[0]; 
//       s.parentNode.insertBefore(hm, s);
//     })();
//   },0);
//   next()
//  })
const whiteList = ['/login', '/home', '/appDevelopIndex', '/community', '/genomeReport', '/appList', '/appDetail',
  //'/researchIndex',//研究所暂时加入白名单
  '/register', '/resetPassword','/upload','/getUploadDataSteps','/geneFAQ','/geneFAQdetail','/modelMarket','/toMiniProgram']// 不重定向白名单

router.beforeEach((to, from, next) => {

  if (to.path === '/login') {
    next();
  } else {
    let token = sessionStorage.getItem('token');

    if (token === null || token === 'null' || token === '') {
      let isWhite = false;
      for (let white of whiteList) {
        if (to.path.startsWith(white)) {
          isWhite = true
        }
      }
      if (isWhite) { // 在免登录白名单，直接进入
        console.log(' 免登录白名单 start path : ', to.path)
        next()
      } else {
        console.log(' token is null into login path : ', to.path)
        next('/login')
      }

      // if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
      //   console.log(' token is null 免登录白名单 into path : ', to.path)
      //   next()
      // } else {
      //   console.log(' token is null into login path : ', to.path)
      //   next('/login')
      // }
      

    } else {
      console.log(' path into  : ', to.path)
      if(to.path !== '/researchIndex/research'){
        if(window.MYtimes){
            clearInterval(window.MYtimes)
        }      
      }
      next();
    }
  }
});
export default router;




// WEBPACK FOOTER //
// ./src/router/index.js